import React from 'react';
import {
  FormControl,
  Box,
  FormHelperText,
  TextField,
} from '@mui/material';

export default function OutputEndpointUrlField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  outputType,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);

    const valid = /^https:\/\//.test(newValue);
    setError(!valid);
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Endpoint'
          id='output_endpoint_url'
          aria-describedby='output-endpoint-url-helper-text'
          variant='outlined'
          fullWidth
          placeholder='https://s3.wasabisys.com'
          onChange={handleChange}
          error={Boolean(error)}
          value={value || ''}
          disabled={!outputType || edit}
        />
        {error ? (
          <FormHelperText id='output-endpoint-url-helper-text'>
            Endpoint Invalid
          </FormHelperText>
        ) : (
          <FormHelperText id='output-endpoint-url-helper-text'>
            Enter the endpoint URL
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

